module.exports = __webpack_public_path__ + "static/img/aezbo-rveno.5a489d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/aezbo-rveno.jpg
// module id = htK5
// module chunks = 0